import { initContract } from '@ts-rest/core';
import { z } from 'zod';
const c = initContract();
/** Mirrors the backend `IdentityDto` (stable HTTP contract). */
export const IdentitySchema = z.object({
    id: z.string(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    email: z.string().nullable(),
});
export const CreateIdentityBodySchema = z.object({
    firstName: z.string().min(1, 'firstName is required'),
    lastName: z.string().min(1, 'lastName is required'),
});
export const UpdateIdentityBodySchema = z.object({
    firstName: z.string().nullable().optional(),
    lastName: z.string().nullable().optional(),
});
export const identityContract = c.router({
    /** Per-id flat routes (the UUID identifies the resource globally). */
    getIdentity: {
        method: 'GET',
        path: '/identities/:identityId',
        pathParams: z.object({ identityId: z.string().min(1) }),
        responses: {
            200: IdentitySchema,
        },
        summary: 'Get an identity by id',
    },
    updateIdentity: {
        method: 'PATCH',
        path: '/identities/:identityId',
        pathParams: z.object({ identityId: z.string().min(1) }),
        body: UpdateIdentityBodySchema,
        responses: {
            200: IdentitySchema,
        },
        summary: 'Update an identity',
    },
    /** Listings nested under the organization (scope in the path). */
    listOrganizationIdentities: {
        method: 'GET',
        path: '/organizations/:organizationId/identities',
        pathParams: z.object({ organizationId: z.string().min(1) }),
        responses: {
            200: z.array(IdentitySchema),
        },
        summary: 'List the identities of an organization',
    },
    listSiteIdentities: {
        method: 'GET',
        path: '/organizations/:organizationId/sites/:siteId/identities',
        pathParams: z.object({
            organizationId: z.string().min(1),
            siteId: z.string().min(1),
        }),
        responses: {
            200: z.array(IdentitySchema),
        },
        summary: 'List the identities of a site',
    },
    createIdentity: {
        method: 'POST',
        path: '/organizations/:organizationId/sites/:siteId/identities',
        pathParams: z.object({
            organizationId: z.string().min(1),
            siteId: z.string().min(1),
        }),
        body: CreateIdentityBodySchema,
        responses: {
            201: IdentitySchema,
        },
        summary: 'Create an identity on a site',
    },
});
